<template>
  <DpaNewsBaseModal
    ref="modal"
    submit-button-appearance="ghost"
    :submit-button-label="t('dpaIdOverlay.openInPlayStore')"
    :cancel-button-label="t('dpaIdOverlay.openInAppStore')">
    <template #header>
      {{ t("dpaId.name") }}
    </template>
    <img
      v-if="imgSrc"
      class="mx-auto w-100"
      alt="dpa-Notify App"
      :src="imgSrc" />
    <h1 class="mb-2 text-xl/snug font-medium text-neutral-primary">
      {{ t("dpaIdOverlay.headline") }}
    </h1>
    <p class="text-sm/normal text-neutral-primary">
      {{ t("dpaIdOverlay.description") }}
    </p>
    <template #footer="{ submitButtonLabel, cancelButtonLabel }">
      <UiButton
        appearance="outline-emphasis"
        data-testid="cancelButton"
        size="md"
        @click="onAppStoreClick">
        {{ submitButtonLabel }}
      </UiButton>
      <UiButton
        appearance="outline-emphasis"
        data-testid="cancelButton"
        size="md"
        @click="onPlayStoreClick">
        {{ cancelButtonLabel }}
      </UiButton>
    </template>
  </DpaNewsBaseModal>
</template>

<script setup lang="ts">
import UiButton from "@dpa-id-components/dpa-shared-components/src/components/UiButton/UiButton.vue";
import { computed, useTemplateRef } from "vue";
import { useI18n } from "vue-i18n";

import DpaNewsBaseModal from "@/components/shared/DpaNewsBaseModal/DpaNewsBaseModal.vue";

import imgDE from "./notificationDE.png";
import imgEN from "./notificationEN.png";
import imgES from "./notificationES.png";

const modal = useTemplateRef<InstanceType<typeof DpaNewsBaseModal>>("modal");

const { t, locale } = useI18n();

const onAppStoreClick = () => {
  window.open("https://apps.apple.com/app/id1484897709", "_blank");
  requestClose();
};

const onPlayStoreClick = () => {
  window.open(
    "https://play.google.com/store/apps/details?id=hub.dpaid.app.production",
    "_blank",
  );
  requestClose();
};

const imgSrc = computed((): string => {
  switch (locale.value) {
    case "de":
      return imgDE;
    case "en":
      return imgEN;
    case "es":
      return imgES;
    default:
      return imgDE;
  }
});

function showModal() {
  modal.value?.showModal();
}

function requestClose() {
  modal.value?.requestClose();
}

function close() {
  modal.value?.close();
}

defineExpose({ showModal, close, requestClose });
</script>
